  
import React, { Component } from 'react';
import { Icon, Table, Ref } from "semantic-ui-react";
import {
  DragDropContext,
  Droppable,
  Draggable,
} from "react-beautiful-dnd";
import invariant from 'tiny-invariant';
import Grid from "../../partials/content/Grid";
import { getBannersByAccount,updateMaster,updateBannerOrder } from "../../crud/auth.crud";

import EditIcon from '@material-ui/icons/Edit';
 import { Link } from "react-router-dom";
 import { Tooltip } from "@material-ui/core";
 import { IconButton } from '@material-ui/core';
 import HighlightOffIcon from '@material-ui/icons/HighlightOff';
 import {  format } from 'date-fns';
 import Button from '@material-ui/core/Button';
 import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import S3Image from "../../widgets/S3Image";
import Linkify from 'react-linkify';


let i = 1;
let filledArr = [...new Array(10)].map(() => ({ 'id': i++, "content": "Bob" }));

 const getHomeColumn = (entities, rowId) => {
  const columnId = entities.columnOrder.find(id => {
    const column = entities.columns[id];
    return column.taskIds.includes(rowId);
  });
  

  invariant(columnId, 'Count not find row for table');

  return entities.columns[columnId];
};

const getFileName = (path) => {
  const separator = path.includes('/') ? '/' : '\\';
  const parts = path.split(separator);
  return parts.pop();
};


const multiSelect = (
  entities,
  selectedRowIds,
  newRowId,
) => {
  // Nothing already selected
  if (!selectedRowIds.length) {
    return [newRowId];
  }

  const columnOfNew = getHomeColumn(entities, newRowId);
  const indexOfNew = columnOfNew.rowIds.indexOf(newRowId);
  const lastSelected = selectedRowIds[selectedRowIds.length - 1];
  const columnOfLast = getHomeColumn(entities, lastSelected);
  const indexOfLast = columnOfLast.rowIds.indexOf(lastSelected);

  // multi selecting to another column
  // select everything up to the index of the current item
  if (columnOfNew !== columnOfLast) {
    return columnOfNew.rowIds.slice(0, indexOfNew + 1);
  }

  // multi selecting in the same column
  // need to select everything between the last index and the current index inclusive

  // nothing to do here
  if (indexOfNew === indexOfLast) {
    return null;
  }

  const isSelectingForwards = indexOfNew > indexOfLast;
  const start = isSelectingForwards ? indexOfLast : indexOfNew;
  const end = isSelectingForwards ? indexOfNew : indexOfLast;

  const inBetween = columnOfNew.rowIds.slice(start, end + 1);

  // everything inbetween needs to have it's selection toggled.
  // with the exception of the start and end values which will always be selected

  const toAdd = inBetween.filter(
    (taskId) => {
      // if already selected: then no need to select it again
      if (selectedRowIds.includes(taskId)) {
        return false;
      }
      return true;
    },
  );

  const sorted = isSelectingForwards ? toAdd : [...toAdd].reverse();
  const combined = [...selectedRowIds, ...sorted];

  return combined;
};

class Banner extends Component {
  state = {
    entities: [],
    reorderEnabled: false,
    selectedRowIds: [],
    draggingRowId: null,
    open:false,
    banner:{}
  };

 handleClose = () =>
  {
    this.setState({open:false});
  }

  deleteBanner(banner)
  {
    banner.isActive=false;
    banner.isDeleted=true;
    updateMaster("banner",banner.id,banner).then(response => response.data)
    .then((data) => {
      //this.setState({ banners: data })
      //console.log(this.state.users)
      this.setState({entities: this.state.entities.map(el => (el.bannerId === banner.bannerId ? {...el, isActive :false}: el))});  

      this.setState({status:true,
                        statusMessage:'Banner deleted successfully',
                        alertType:'alert-success'});
                         window.scrollTo(0,0);
     })
  }

  componentDidMount () {

    getBannersByAccount().then(response => response.data)
    .then((data) => {
      this.setState({ entities: data })
      //console.log(this.state.users)
     })

    window.addEventListener('click', this.onWindowClick);
    window.addEventListener('keydown', this.onWindowKeyDown);
    window.addEventListener('touchend', this.onWindowTouchEnd);
  }

  componentWillUnmount () {
    window.removeEventListener('click', this.onWindowClick);
    window.removeEventListener('click', this.onWindowClick);
    window.removeEventListener('click', this.onWindowClick);
  }

  getItemStyle = (isDragging, draggableStyle) => ({
    background: isDragging && ("lightblue"),
    ...draggableStyle,
  })

  reOrder = () => {
    const { reorderEnabled } = this.state

    this.setState({
      reorderEnabled: !reorderEnabled
    })
  }

  saveOrder = () => {
    // const { entities } = this.state;
    // Take new state of dispo group list and POST to endpoint
    //console.log("save order::::",this.state.entities);
    let bannerList = [];
    this.state.entities.map((e)=>(
        bannerList.push(e.bannerId)
    ));
    updateBannerOrder(bannerList).then(response => response.data)
    .then((data) => {
      //this.setState({ banners: data })
      //console.log(this.state.users)
      //this.setState({entities: this.state.entities.map(el => (el.bannerId === banner.bannerId ? {...el, isActive :false}: el))});  

      this.setState({status:true,
                        statusMessage:'Banner order updated successfully',
                        alertType:'alert-success'});
                         window.scrollTo(0,0);
     })

  }

  onDragStart = start => {
    const id = start.draggableId;
    const selected = this.state.selectedRowIds.find(selectedId => selectedId === id);

    // If dragging an item that is not selected, unselect all items
    if (!selected) {
      this.unselectAll();
    }

    this.setState({
      draggingRowId: start.draggableId,
    });
  }

  onDragEnd = result => {
    const { destination, source, reason } = result;

    // Not a thing to do...
    if (!destination || reason === 'CANCEL') {
      this.setState({
        draggingRowId: null,
      });
      return;
    }

    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    ) {
      return;
    }

    const entities = Object.assign([], this.state.entities);
    const quote = this.state.entities[source.index];
    entities.splice(source.index, 1);
    entities.splice(destination.index, 0, quote);

    this.setState({
      entities
    });
  }

  unselect = () => {
    this.unselectAll();
  }

  unselectAll = () => {
    this.setState({
      selectedRowIds: [],
    });
  }

  multiSelectTo = newRowId => {
    const updated = multiSelect(
      this.state.entities,
      this.state.selectedRowIds,
      newRowId,
    );

    if (updated == null) {
      return;
    }

    this.setState({
      selectedRowIds: updated,
    });
  }

  onWindowKeyDown = event => {
    if (event.defaultPrevented) {
      this.unselectAll();
    }

    if (event.key === `Escape`) {
      this.unselectAll();
    }
  }

  onWindowClick = event => {
    if (event.defaultPrevented) {
      return;
    }
    this.unselectAll();
  }

  onWindowTouchEnd = event => {
    if (event.defaultPrevented) {
      return;
    }
    this.unselectAll();
  }

  toggleSelection = rowId => () => {
    const selectedRowIds = this.state.selectedRowIds;
    const wasSelected = selectedRowIds.includes(rowId);

    const newRowIds = (() => {
      // Row was not previously selected, now will be the only selected row
      if (!wasSelected) {
        return [rowId];
      }
      // Row was part of a selected group of rows, will now become the only selected row
      if (selectedRowIds.length > 1) {
        return [rowId];
      }
      // Row was previously selected but not in a group, will now clear the selection
      return [];
    })();

    this.setState({
      selectedRowIds: newRowIds,
    });
  }

  toggleSelectionInGroup = rowId => {
    const selectedRowIds = this.state.selectedRowIds;
    const index = selectedRowIds.indexOf(rowId);

    // If not selected, add it to the selected rows
    if (index === -1) {
      this.setState({
        selectedRowIds: [...selectedRowIds, rowId],
      });
      return;
    }
    // If row was previously selected, now it needs to be removed from the group
    const shallow = [...selectedRowIds];
    shallow.splice(index, 1);
    this.setState({
      selectedRowIds: shallow,
    });
  }

  render() {
    const { reOrder, saveOrder } = this;
    const { entities, selectedRowIds, reorderEnabled } = this.state;
    const selected = selectedRowIds;

    return (
      <>
        {this.state.status && (
                        <div role="alert" className={"alert "+this.state.statusColor}>
                          <div className="alert-text">{this.state.statusMessage}</div>
                        </div>
                      )}
        <div className="row">
          <div className="col-md-12">
            <Grid beforeCodeTitle="Banner" jsCode="true" createPath="/createbanner">
              <div className="kt-section">
                <div style={{ padding: "30px" }}>
                  {/*<Button onClick={reOrder}>{reorderEnabled ? "Cancel Reorder" : "Toggle Reorder"}</Button>*/}
                  <Button color="primary" variant="outlined" onClick={saveOrder}>Save New Order</Button>
                  <DragDropContext
                    onDragStart={this.onDragStart}
                    onDragEnd={this.onDragEnd}
                  >
                    <Table>
                      <Table.Header>
                        <Table.Row>
                          {reorderEnabled && (<Table.HeaderCell />)}
                          <Table.HeaderCell>Banner Type</Table.HeaderCell>
                          <Table.HeaderCell>Publish To</Table.HeaderCell>
                          <Table.HeaderCell>Publish Date</Table.HeaderCell>
                          <Table.HeaderCell>Expiry Date</Table.HeaderCell>
                          <Table.HeaderCell>Display Time</Table.HeaderCell>
                          <Table.HeaderCell>Display Order</Table.HeaderCell>
                          <Table.HeaderCell>Edit</Table.HeaderCell>
                          <Table.HeaderCell>Delete</Table.HeaderCell>
                        </Table.Row>
                      </Table.Header>
                      <Droppable droppableId="tableBody">
                        {(provided, snapshot) => (
                          <Ref innerRef={provided.innerRef}>
                            <Table.Body {...provided.droppableProps}>
                              {this.state.entities.filter(b=> b.isActive==true).map((entity, index) => (
                                <Draggable
                                  draggableId={entity.id}
                                  index={index}
                                  key={entity.id}
                                >
                                  {(provided, snapshot) => (
                                    <Ref innerRef={provided.innerRef}>
                                      <Table.Row
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        style={this.getItemStyle(
                                          snapshot.isDragging,
                                          provided.draggableProps.style
                                        )}
                                      >
                                        {reorderEnabled && (<Table.Cell>{
                                          <Icon
                                            name="bars"
                                            color="grey"
                                            className="ds__DispoGroup__row-drag"
                                          />
                                        }</Table.Cell>)}
                                        <Table.Cell>
                                          <Tooltip
                                                      title={entity.bannerType=='image' ? getFileName(entity.imagePath) : entity.message} >
                                          <Link onClick={()=>this.setState({open:true,banner:entity})}>
                                            {entity.bannerType=='image' ? 'Banner Image' : 'Announcement Content'}
                                          </Link>
                                          </Tooltip>
                                        </Table.Cell>
                                        <Table.Cell>{entity.publishTo==="allaccounts" && "All accounts"}
                                          {entity.publishTo==="subaccounts" && "Connected accounts"}
                                           {entity.publishTo==="private" && "My account"}
                                        </Table.Cell>
                                        <Table.Cell>{format(new Date(entity.publishDate), 'MM/dd/yyyy')}</Table.Cell>
                                        <Table.Cell>{format(new Date(entity.expiryDate), 'MM/dd/yyyy')}</Table.Cell>
                                        <Table.Cell>{entity.displayTime}</Table.Cell>
                                        <Table.Cell>{entity.displayOrder}</Table.Cell>
                                        <Table.Cell>
                                            <Link  to={{pathname:"/editbanner", data: {banner:entity}}}>
                                             <Tooltip
                                                      title="Edit Banner" 

                                                    >
                                              <IconButton>
                                                <EditIcon style={{ color: '#5578eb',fontSize: 12}}/>   
                                              </IconButton>
                                              </Tooltip>
                                            </Link>
                                        </Table.Cell>
                                        <Table.Cell>
                                            <Tooltip title="Delete Banner">
                                              <IconButton onClick={()=>this.deleteBanner(entity)}>
                                                <HighlightOffIcon style={{ color: '#5578eb',fontSize: 18}}/>  
                                              </IconButton>
                                            </Tooltip>
                                        </Table.Cell>
                                      </Table.Row>
                                    </Ref>
                                  )}
                                </Draggable>
                              ))}
                              {provided.placeholder}
                            </Table.Body>
                          </Ref>
                        )}
                      </Droppable>
                    </Table>
                  </DragDropContext>
                </div>
              </div>
            </Grid>
          </div>
        </div>

        {this.state.open && this.state.banner != null &&
        <Dialog open={this.state.open} onClose={this.handleClose} aria-labelledby="form-dialog-title">
        
       
        

        <DialogTitle id="form-dialog-title">{this.state.banner.bannerType =='image' ? 'Banner Image' : 'Announcement Content' + " Preview"}</DialogTitle>
        <DialogContent>
         {this.state.banner.bannerType == 'image' && 
          <S3Image id={this.state.banner.bannerId} originalFileKey={this.state.banner.imagePath}/>
         }
         {this.state.banner.bannerType == 'text' && 
         <div class="col">
          <div class="alert alert-light alert-elevate fade show" role="alert">
            <div class="alert-icon"><i class="flaticon-warning kt-font-brand"></i></div>
              <div class="alert-text" style={{'font-size':'20px', 'font-weight': 'bold'}}>
               
                <Linkify properties={{target: '_blank', style: {color: 'blue', fontWeight: 'bold'}}}>  {this.state.banner.message}</Linkify>
              </div>
            </div>
         </div>
        }
         
        </DialogContent>
      

       
          
    
      </Dialog>
      }

      </>
    );
  }
}

export default Banner;